import { useContext } from 'react';
import { CurrentScreenDataContext } from '../contexts/CurrentScreenDataContext';

/**
 * Custom hook to access the CurrentScreenDataContext.
 * Returns { state, dispatch } from the nearest CurrentScreenDataProvider.
 */
const useCurrentScreenDataContext = () => {
    return useContext(CurrentScreenDataContext);
};

export default useCurrentScreenDataContext;
